<ion-grid>
  <ion-row>
    <ion-col class="vehicle-container-w">
      <h2 class="car-title">
        {{ vehicle.vendor }} {{ vehicle.information.model }} ({{
          vehicle.information.year
        }})
      </h2>
      <div *ngIf="hasInterventions()">
        <ion-row class="interventionMsg" (click)="showModal()">
          <ion-col>
            <div>
              <p><strong>Noe er galt med ditt oppsett</strong></p>
              <p>Se hva du må gjøre</p>
            </div>
          </ion-col>
          <ion-col size="2" class="arrow-forward">
            <ion-button class="">Vis</ion-button>
          </ion-col>
        </ion-row>
      </div>
      <div *ngIf="locations?.length === 0">
        <ion-row class="locationMsg">
          <ion-col>
            <div>
              <p><strong>Legg til en adresse</strong></p>
              <p>For å bruke smartlading må du legge til en adresse</p>
            </div>
          </ion-col>
          <ion-col size="2" class="location-button">
            <ion-button (click)="showLocationModal()" class=""
              >Legg til</ion-button
            >
          </ion-col>
        </ion-row>
      </div>
      @if (vehicle.capabilities.chargeState.isCapable) {
        <div class="doughnut-container">
          <app-battery-doughnut
            *ngIf="
              vehicle.chargeState?.batteryLevel !== null &&
              vehicle.chargeState?.range !== null
            "
            [chartId]="vehicle.id"
            [batteryLevel]="vehicle.chargeState.batteryLevel"
            [batteryRange]="vehicle.chargeState.range"
          ></app-battery-doughnut>
          <p
            *ngIf="
              !vehicle.chargeState?.batteryLevel === null ||
              !vehicle.chargeState?.range === null
            "
          >
            Vi jobber med å hente data om din bil. Mer informasjon vil dukke opp
            her etter hvert.
          </p>
        </div>
      } @else {
        <div>
          <p>
            Denne bilen har ikke tilstrekkelig støtte for å bruke smartlading.
          </p>
        </div>
      }
      <div class="centered-container">
        <p class="car-connected">
          {{ connectionState }}
          <app-status-icon
            [vehicle]="vehicle"
            [smartStatus]="smartChargeStatus"
          ></app-status-icon>
        </p>
      </div>
      @if (vehicle.capabilities.location.isCapable) {
        <p class="smalltext pre-line beige-box">
          <ion-icon name="location"></ion-icon>
          {{ locationState }}
        </p>
      }

      <div *ngIf="locations?.length > 0">
        <app-smart-charging
          [vehicle]="vehicle"
          [smartChargeStatus]="smartChargeStatus"
        ></app-smart-charging>
      </div>

      <app-smart-charge-override
        [vehicle]="vehicle"
        [smartChargeStatus]="smartChargeStatus"
      ></app-smart-charge-override>
      @if (vehicle.capabilities.smartCharging.isCapable) {
        <div class="mt-8">
          <ion-button class="secondary" (click)="showEventLog = true"
            >Se tidligere ladeplaner
            <ion-icon name="arrow-forward-outline"></ion-icon>
          </ion-button>
          <ion-modal
            [isOpen]="showEventLog"
            cssClass="event-log-modal-content"
            backdropDismiss
            (didDismiss)="showEventLog = false"
          >
            <ng-template>
              <app-event-log-modal [vehicleId]="vehicle.id"></app-event-log-modal>
            </ng-template>
          </ion-modal>
        </div>
      }
    </ion-col>
  </ion-row>
</ion-grid>
